import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import FormatListBulletedOutlinedIcon from '@mui/icons-material/FormatListBulletedOutlined';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import FormatShapesOutlinedIcon from '@mui/icons-material/FormatShapesOutlined';
import Cafe24DesignSyncMenuIcon from './Cafe24DesignSyncMenuIcon';
import ShopbySyncMenuIcon from './ShopbySyncMenuIcon';
import NaverSyncMenuIcon from './NaverSyncMenuIcon';
import DvrOutlinedIcon from '@mui/icons-material/DvrOutlined';
import InventoryOutlinedIcon from '@mui/icons-material/InventoryOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import DisplaySettingsOutlinedIcon from '@mui/icons-material/DisplaySettingsOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import PodProductListMenuIcon from './PodProductListMenuIcon';
import PrePaymentMenuIcon from './PrePaymentMenuIcon';
import BrandManagementMenuIcon from './BrandManagementMenuIcon';
import SubChannelMenuIcon from './SubChannelMenuIcon';
import StoreConnectMenuIcon from './StoreConnectMenuIcon';

// 메뉴의 url, id, title 등으로 매핑 (url 추천)
export const MenuIcons: Record<string, React.ReactNode> = {
  // 홈
  '/main': <HomeOutlinedIcon />,

  // 판매 상품 관리
  '/channelProductManagement': <ShoppingBagOutlinedIcon />,

  // 전체 상품 리스트
  '/product/sales': <FormatListBulletedOutlinedIcon />,

  // MY POD 상품 리스트
  '/podproductlist': <PodProductListMenuIcon />,

  // POD 상품 관리
  '/designTemplates': <ManageAccountsOutlinedIcon />,

  // POD 상품 관리
  '/approvedDesigns': <FormatShapesOutlinedIcon />,

  // Cafe24 상품 연동
  '/cafe24DesignSync': <Cafe24DesignSyncMenuIcon />,

  // Shopby 상품 연동
  '/designSync/shopby': <ShopbySyncMenuIcon />,

  // SmartStore 상품 연동
  '/designSync/naverstore': <NaverSyncMenuIcon />,

  // 디자인 관리
  '/designs': <DvrOutlinedIcon />,

  // 주문 관리
  '/orderManagement': <InventoryOutlinedIcon />,

  // 채널 관리
  '/channelManagement': <DisplaySettingsOutlinedIcon />,

  // 설정
  '/adminManagement': <SettingsOutlinedIcon />,

  // 통계
  '/report': <BarChartOutlinedIcon />,

  // 브랜드 관리
  '/brand': <BrandManagementMenuIcon />,

  // 공지사항
  '/notice': <ArticleOutlinedIcon />,

  // 제작비 결제관리
  '/prepayManagement': <PrePaymentMenuIcon />,

  // 서브채널 관리
  '/subchannelManagement': <SubChannelMenuIcon />,

  // 스토어 연동
  '/StoreConnect': <StoreConnectMenuIcon />,
};
